export default [
    {
        name: 'companyList',
        path: '/company/list',
        component: require('@/pages/CompanyList').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'company' })
        }
    },
    {
        name: 'companyCreate',
        path: '/company/create',
        component: require('@/pages/CompanyCreate').default,
        meta: {
            back: { label: 'Companies', to: '/company/list' },
            security: (auth) => auth.can({ action: 'create', model: 'company' })
        }
    },
    {
        name: 'companyView',
        path: '/company/view/:companyId',
        component: require('@/pages/CompanyView').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            back: { label: 'Companies', to: '/company/list' },
            security: (auth) => auth.can({ action: 'view', model: 'company', arg: +auth.to.params.companyId })
        }
    },
    {
        name: 'companyEdit',
        path: '/company/edit/:companyId',
        component: require('@/pages/CompanyEdit').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            back: { label: ':companyName', to: '/company/view/:companyId' },
            security: (auth) => auth.can({ action: 'edit', model: 'company', arg: +auth.to.params.companyId })
        }
    },
    {
        name: 'companySetup',
        path: '/company/setup/:companyId',
        component: require('@/pages/CompanyUserSetup').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            back: { label: ':companyName', to: '/company/view/:companyId' },
            security: (auth) => auth.can({ action: 'edit', model: 'company', arg: +auth.to.params.companyId })
        }
    },
]
